import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  CanActivateFn,
  GuardResult,
  MaybeAsync,
  RedirectCommand,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import {
  EnvironmentInjector,
  inject,
  runInInjectionContext,
} from '@angular/core';
import { concat, first, last, Observable, takeWhile } from 'rxjs';
import { wrapIntoObservable } from '../functions/functions';

export function runInSerialGuard(
  guards: CanActivateFn[] | CanActivateChildFn[],
): CanActivateFn | CanActivateChildFn {
  return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const environmentInjector: EnvironmentInjector =
      inject(EnvironmentInjector);
    const observables: Observable<boolean | UrlTree | RedirectCommand>[] =
      guards.map((guard) => {
        const guardResult: MaybeAsync<GuardResult> = runInInjectionContext(
          environmentInjector,
          () => guard(route, state),
        );
        return wrapIntoObservable(guardResult).pipe(first());
      });
    return concat(...observables).pipe(
      takeWhile((v) => v === true, true),
      last(),
    );
  };
}
